'use client';

import { LinkButton, LinkButtonProps } from '@/ui/Button';

import { AppLink } from '../AppLink';

export type CtaLinkButtonProps = Omit<LinkButtonProps, 'href'> & {
    url: string;
};

export function CtaLinkButton({ url, ...props }: CtaLinkButtonProps) {
    return (
        <AppLink href={url}>
            <LinkButton {...props} />
        </AppLink>
    );
}
